import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { Addresses_FlowService } from './Addresses.flow.index';
import { Carriers_FlowService } from './Carriers.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { Materials_FlowService } from './Materials.flow.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';
import { Reports_FlowService } from './Reports.flow.index';

import { app_custom_save_placard_report_as_attachmentService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Addresses = this.injector.get(Addresses_FlowService);
    this.Carriers = this.injector.get(Carriers_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.SalesOrders = this.injector.get(SalesOrders_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.Materials = this.injector.get(Materials_FlowService);
    this.Invoices = this.injector.get(Invoices_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
    this.Reports = this.injector.get(Reports_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public Addresses: Addresses_FlowService;
    public Carriers: Carriers_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public SalesOrders: SalesOrders_FlowService;
    public Notifications: Notifications_FlowService;
    public Materials: Materials_FlowService;
    public Invoices: Invoices_FlowService;
    public Inventory: Inventory_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
    public Reports: Reports_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _custom_save_placard_report_as_attachment: app_custom_save_placard_report_as_attachmentService;
  public async custom_save_placard_report_as_attachment($inParams: {  }): Promise< { results?: any[] }> {
    if(!this._custom_save_placard_report_as_attachment) { 
      this._custom_save_placard_report_as_attachment = this.injector.get(app_custom_save_placard_report_as_attachmentService);
    }
    return this._custom_save_placard_report_as_attachment.run($inParams);
  }
   
   

   
}
